import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";

export const materialIconRegistryInitializer =
  (domSanitizer: DomSanitizer, matIconRegistry: MatIconRegistry) =>
  (): boolean => {
    const iconsPath = "/assets/icons";

    const iconsList = [
      "checked",
      "closed",
      "error",
      "eye",
      "crossed",
      "help",
      "home",
      "logout",
      "menu",
      "like",
      "user",
      "building",
      "close-circle",
      "danger",
      "danger2",
      "info-circle",
      "tick-circle",
      "close",
      "earth",
      "arrow-right",
      "arrow-right-2",
      "arrow-left",
      "arrow-up",
      "arrow-down",
      "arrow-down-thin",
      "hexagonal-warning-sign",
      "fuel-station",
      "plus-station",
      "exclamation-circle",
      "message-question",
      "message-question2",
      "green-arrow-up",
      "red-arrow-down",
      "search",
      "clock",
      "close-chatboot",
      "arrow-square-down",
      "arrow-down-outline",
      "dots",
      "invoice",
      "navigation-button",
      "download",
      "settings",
      "bell",
      "star",
      "action-send",
      "action-edit",
      "action-delete",
      "add",
      "modal-red-icon",
      "settings-button",
      "filter",
      "edit",
      "folder",
      "modal-red-question",
      "settings-white",
      "ai-logo",
      "chatbot-logo",
      "calendar",
    ];

    [
      ...iconsList.map((icon) => [`${icon}`, `${iconsPath}/${icon}.svg`]),
    ].forEach(([iconName, iconUrl]) =>
      matIconRegistry.addSvgIcon(
        iconName,
        domSanitizer.bypassSecurityTrustResourceUrl(iconUrl),
      ),
    );

    return true;
  };
